export default "__VITE_ASSET__9311d506__"